// K2D "Könyvelési sablonok" (w_popupu_hmboktranstemp / w_resp_hmboktranstemp) modelljei.
// A tétel total mező arány-szorzó (0..1, 3 tizedes), NEM összeg: betöltéskor a spp_trtemp_load
// szorozza fel a megadott összeggel, az oldalankénti utolsó tétel a kerekítési maradékot kapja.

export interface BookingTemplateListItem {
  id: number;
  selected?: boolean; // UI-only: a detail-sor (tételek előnézet / törlés-megerősítő) nyitott állapota
  name: string;
  english: string | null;
  foreign1: string | null;
  accEvent: string | null;
  remark: string | null;
  insDate: string;
  userId: number;
  createdBy: string | null; // létrehozó felhasználó neve (msuser.name)
}

export interface BookingTemplateItemDimension {
  id: number;
  deleting?: boolean; // UI-only: a soron belüli (sárga) törlés-megerősítő detail-sor nyitott állapota
  dimCodeType: number; // 5..10 = 4..9. dimenzió (K2D tab IV-IX)
  dimCode: number;
  dimCodeDisplay: string | null;
  total: number;
}

export interface BookingTemplateItem {
  id: number;
  uid?: number; // UI-only stabil sor-kulcs a Kendo grid / szerkesztő számára (nem megy a backendre)
  deleting?: boolean; // UI-only: a soron belüli (sárga) törlés-megerősítő detail-sor nyitott állapota
  showDimensions?: boolean; // UI-only: a tétel dimenzió detail-sorának nyitott állapota (lista előnézet)
  accSign: string; // '+' = tartozik, '-' = követel
  accno: number;
  accnoCode: string | null;
  accnoName: string | null;
  total: number;
  currency: string | null;
  note: string | null;
  bookType: number;
  bookTypeDisplay: string | null; // napló megnevezése (csbokbooktype.national) — csak megjelenítés
  dimcode1: number;
  dimcode2: number;
  dimcode3: number;
  dimcode1Display: string | null;
  dimcode2Display: string | null;
  dimcode3Display: string | null;
  invNo: number; // összerendelési csoport, 1 = nincs
  dimensions: BookingTemplateItemDimension[];
}

export interface BookingTemplate {
  id: number;
  name: string;
  english: string | null;
  foreign1: string | null;
  remark: string | null;
  accEvent: string | null;
  deleted: boolean;
  insDate: string;
  userId: number;
  createdBy?: string | null; // létrehozó felhasználó neve (msuser.name) — csak megjelenítés
  items: BookingTemplateItem[];
}

export function emptyBookingTemplate(): BookingTemplate {
  return {
    id: 0,
    name: "",
    english: null,
    foreign1: null,
    remark: null,
    accEvent: null,
    deleted: false,
    insDate: "",
    userId: 0,
    createdBy: null,
    items: [],
  };
}

export function emptyBookingTemplateItem(accSign: string, total: number): BookingTemplateItem {
  return {
    id: 0,
    deleting: false, // kezdőérték, hogy a törlés-megerősítő detail-sor reaktív legyen (Vue 2)
    accSign,
    accno: 0,
    accnoCode: null,
    accnoName: null,
    total,
    currency: null,
    note: null,
    bookType: 11, // K2D d_g_imboktranstemp initial
    bookTypeDisplay: null,
    dimcode1: 1,
    dimcode2: 1,
    dimcode3: 1,
    dimcode1Display: null,
    dimcode2Display: null,
    dimcode3Display: null,
    invNo: 1,
    dimensions: [],
  };
}

export interface BookingTemplateActionResult {
  success: boolean;
  message: string;
  id: number;
  needsOverwrite: boolean;
}

// Sablon betöltése tranzakcióba (K2D w_popupu_hmboktranstemp load mód, dw_2)
export interface LoadBookingTemplateParams {
  templateId: number;
  transId: number;
  total: number;
  copyAccEvent: boolean;
  copyInvNo: boolean;
}

// Tranzakció mentése sablonként (K2D w_popup_temp_save)
export interface SaveAsBookingTemplateParams {
  transId: number;
  name: string;
  english: string | null;
  foreign1: string | null;
  remark: string | null;
  accEvent: string | null;
  overwrite: boolean;
}
